import React from 'react';
import { Link } from 'react-router-dom';
import { Hero } from '../components/Hero';
import { SocialProof } from '../components/SocialProof';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { BonusBundle } from '../components/BonusBundle';
import { Testimonials } from '../components/Testimonials';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { FloatingCTA } from '../components/FloatingCTA';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  return <div className="min-h-screen bg-cream-light font-sans text-gray-900 pb-24 sm:pb-0" data-id="element-286">
      <FloatingCTA data-id="element-287" />
      <RecentPurchaseToast data-id="element-288" />
      <main data-id="element-289">
        <Hero data-id="element-290" />
        <SocialProof data-id="element-291" />
        <Problem data-id="element-292" />
        <Solution data-id="element-293" />
        <BonusBundle data-id="element-294" />
        <Testimonials data-id="element-295" />
        <Pricing data-id="element-296" />
        <FAQ data-id="element-297" />
      </main>

      <footer className="bg-gray-900 text-white py-12 text-center" data-id="element-298">
        <div className="max-w-7xl mx-auto px-4" data-id="element-299">
          <p className="font-serif text-2xl font-bold mb-4" data-id="element-300">MÁS AÑOS JUNTOS</p>
          <p className="text-gray-400 text-sm mb-8" data-id="element-301">
            El Método Maestro de Bio-Nutrición y Convivencia
          </p>
          <div className="flex justify-center space-x-6 text-sm text-gray-500 mb-8" data-id="element-302">
            <Link to="/terminos" className="hover:text-white transition-colors" data-id="element-303">
              Términos
            </Link>
            <Link to="/privacidad" className="hover:text-white transition-colors" data-id="element-304">
              Privacidad
            </Link>
          </div>
          <p className="text-gray-600 text-xs" data-id="element-305">
            © {new Date().getFullYear()} Más Años Juntos. Todos los derechos
            reservados.
            <br data-id="element-306" />
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          </p>
        </div>
      </footer>
    </div>;
}